export enum AiEmbedType {
    CNG_PRODUCT = "cngProduct",
    MEDIA = "Media",
    PRODUCT = "product"
}
